
// initial state
const state = {
  count: 0,
  search: false,
  inputValue: '',
}

// getters
const getters = {
  getMode: state => {
    return state.search;
  },
  getAllData: state => {
    return state.data;
  },
  getInputValue: state => {
    return state.inputValue;
  }
}

// actions
const actions = {
}

// mutations
const mutations = {
  searchModeOn (state) {
    state.search = true;
  },
  searchModeOff (state) {
    state.search = false;
  },
  setInputValue (state, data) {
    state.inputValue = data.value;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js